import { Partner } from '@iotv/datamodel-core';
import { getViewDefinitionFromUserAttributes } from '../factories/AttributeDefinitions';
const PartnerViewDefinition = getViewDefinitionFromUserAttributes(new Partner().getUserAttributes());
delete PartnerViewDefinition.type;
export { PartnerViewDefinition };
